import { IFilterDto } from "@framework/types";

export const emptyFilters: IFilterDto = {
  equipmentGroup: 0,
  instanceNumber: "",
  manufacturer: 0,
  path: 0,
  rfid: "",
  technologicalProcess: 0,
  trainName: "",
  trainPosition: "",
  trainSerial: "",
  trainType: 0,
};
